import React from 'react'

const GalleryList = () => {
  return (
    <div>GalleryList</div>
  )
}

export default GalleryList